import { requestTimeout, handleResponse } from "../utils";

const apiUrl = process.env.REACT_APP_API_URL;
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME;

export const answerApi = {
  _storeMultipleAnswers,
  _checkUserProgress,
  _getQuizResult,
};

async function _storeMultipleAnswers(data) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(data),
  };

  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "account/user-answers/multiple", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _checkUserProgress(data) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(data),
  };

  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "account/user-answers/progress", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _getQuizResult(slug) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "account/progress/" + slug, requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}
